import React from 'react';
import styled from 'styled-components';

import theme from '../../../style/theme';

const PostPreviewStyles = styled.div`
  flex: 1 0 270px;
  box-shadow: 0 3px 6px rgba(0,0,0,.16);
  border-radius: .2em;
  padding: 2rem 1rem 1rem;
  background: #fcfcfc;
  margin: 1.25rem;
  display: flex;
  flex-direction: column;
`;

const TitleStyles = styled.h3`
  font-weight:normal;
  font-size: 1.2rem;
  line-height: 1.2;
  color: #707070;
  margin-bottom: 0;
`;

const DateStyles = styled.span`
  font-size: .8rem;
  line-height: 1.2;
  margin-top: .4rem;
`;

const BodyStyles = styled.div`
  margin-top: 1rem;
  font-size: .8rem;
  display: flex;
  flex-grow: 1;
`;

const LinkStyles = styled.a`
  color: ${theme.colors.primary};
  font-weight: bold;
  text-decoration: none;
  font-size: .9rem;
`;

export const PostPreview = (props) => {
  const { title, link, date } = props;
  const excerpt = `${props.excerpt.substring(0, 100).trim()}... </p>`;
  const timestamp = new Date(Date.parse(date));
  return (
    <PostPreviewStyles>
      <TitleStyles>{title}</TitleStyles>
      <DateStyles>{timestamp.toLocaleDateString('pt-BR')}</DateStyles>
      <BodyStyles dangerouslySetInnerHTML={{ __html: excerpt }} />
      <p className="text_right mg_none">
        <LinkStyles href={link}>Leia Mais</LinkStyles>
      </p>
    </PostPreviewStyles>
  );
};

export default PostPreview;




// WEBPACK FOOTER //
// ./src/components/Index/Posts/PostPreview.jsx